import emptyApi from '@epi-api/emptyApi';
import config from '@epi-config';
import { post, get } from '@epi-helpers/FetchHelpers';
import {
  ImportStatusResponse,
  ImportUserDataPayload,
  ImportUserDataResponse,
  ValidateUserDataPayload,
  ValidateUserDataResponse
} from '@epi-models/pages/MassUpload';

const validateUserDataRequest = async (
  payload: ValidateUserDataPayload
): Promise<{ data: ValidateUserDataResponse } | { error: any }> => {
  try {
    const response = await post<ValidateUserDataResponse>(
      `${config.apiHost}/api/ingestro/validate-user-data`,
      payload
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

const importUserDataRequest = async (
  payload: ImportUserDataPayload
): Promise<{ data: ImportUserDataResponse } | { error: any }> => {
  try {
    const response = await post<ImportUserDataResponse>(
      `${config.apiHost}/api/ingestro/import-user-data`,
      payload
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

const cancelImportRequest = async (
  requestId: number
): Promise<{ data: void } | { error: any }> => {
  try {
    await post(
      `${config.apiHost}/api/ingestro/cancel-import-user-data/${requestId}`,
      undefined
    );
    return { data: undefined };
  } catch (e) {
    return { error: e };
  }
};

export const getImportStatusRequest = async (
  requestId?: number
): Promise<{ data?: ImportStatusResponse; error?: any }> => {
  try {
    const response: ImportStatusResponse | undefined = await get(
      `${config.apiHost}/api/ingestro/import-status${
        requestId ? `?requestId=${requestId}` : ''
      }`
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const massUploadApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    validateUserData: build.mutation<
      ValidateUserDataResponse,
      ValidateUserDataPayload
    >({
      queryFn: (payload: ValidateUserDataPayload) =>
        validateUserDataRequest(payload)
    }),
    importUserData: build.mutation<
      ImportUserDataResponse,
      ImportUserDataPayload
    >({
      queryFn: (payload: ImportUserDataPayload) =>
        importUserDataRequest(payload)
    }),
    cancelImport: build.mutation<void, { requestId: number }>({
      queryFn: ({ requestId }) => cancelImportRequest(requestId)
    }),
    getImportStatus: build.query<ImportStatusResponse, { requestId?: number }>({
      queryFn: ({ requestId }: { requestId?: number }) =>
        getImportStatusRequest(requestId),
      keepUnusedDataFor: 300
    })
  })
});

export const {
  useValidateUserDataMutation,
  useImportUserDataMutation,
  useCancelImportMutation,
  useGetImportStatusQuery,
  useLazyGetImportStatusQuery
} = massUploadApi;
